import type { NetworkingTag } from '@/features/networking'

/**
 * A justificativa da sugestão. Não é decoração: é o que permite ao participante
 * entender por que aquilo apareceu e, se discordar, corrigir as próprias tags.
 *
 * Chip neutro, e não `Badge`: o vocabulário do `Badge` é de status (nova, sucesso,
 * expirado) e pintaria a tag com um significado que ela não tem.
 *
 * `text-sm` e não `text-xs`: ACCESSIBILITY §2.2 só libera 12px para rótulo
 * redundante com ícone e cor, e o nome da tag é informação exclusiva — é ele que
 * explica a sugestão.
 */
export const MatchedTagList = ({ tags }: { tags: NetworkingTag[] }) => {
  if (!tags.length) return null

  return (
    <ul className="flex flex-wrap gap-1.5" aria-label="Interesses em comum">
      {tags.map(tag => (
        <li
          key={tag.id}
          className="inline-flex items-center rounded-full border border-border bg-accent px-2.5 py-0.5 text-sm font-medium text-foreground"
        >
          {tag.name}
        </li>
      ))}
    </ul>
  )
}
